import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import OobSmsChallengeRequest from '../challenge-request/OobSmsChallengeRequest';
import { connect } from 'react-redux';
import { faSms } from '@fortawesome/free-solid-svg-icons';

class OobSmsAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faSms
  static authname = "SMS OTP"
  static description = "Receive an OTP via SMS"
  static authLevel = 850

  static challengeRequestComponent = OobSmsChallengeRequest

  get enrolled(): boolean {
    try {
      return this.props.authmethods.oobSms.enrolled
    } catch (err) {
      return false
    }
  }

  get required(): boolean {
    return this.props.challenge.requiredCredentials.oobSms ? true : false
  }
}

const mapStateToProps = ({ authmethods, challenge }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(OobSmsAuthButton)